export default "__VITE_ASSET__0f04701c__"